import {computed, defineComponent, type PropType, ref, watch} from 'vue';
import {
    ActorSearchResult,
    AnnouncementDto,
    type OperationsActorServiceInfo
} from "@/api/enterprise-gateway-api.proxy.ts";
import * as yup from "yup";
import {useForm} from "vee-validate";
import {useOrganisationStore} from "@/app/stores/organisation-store.ts";
import {storeToRefs} from "pinia";
import {useModalEventsUtil} from "@/app/shared/helpers/modal-events-util.ts";
import DateUtil from "@/app/shared/helpers/date-util.ts";
import {Column, DataTable, type DataTableRowClickEvent} from 'primevue';

export default defineComponent({
    name: 'AegAnnouncements',
    components: { DataTable, Column },
    props: {
        announcements: {
            type: Object as PropType<ActorSearchResult[]>,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    emits: {
        'on-click': (announcementId: string | undefined) => true,
    },
    setup: function (props, {emit}) {
        const announcementList = ref<AnnouncementDto[]>([]);
        const emptyState = ref<boolean>(false);
        const announcementsChanged = (newAnnouncements: AnnouncementDto[]) => {
            announcementList.value = newAnnouncements;
            emptyState.value = newAnnouncements.length === 0;
        }

        const formatDate = (announcement:  AnnouncementDto) => {
            if (!!announcement.to) {
                return `${DateUtil.formatDate(announcement.from)} tot en met ${DateUtil.formatDate(announcement.to)}`;
            } else {
                return DateUtil.formatDate(announcement.from);
            }
        }

        const onRowClick = (event: DataTableRowClickEvent) => {
            const announcement: AnnouncementDto = event.data;
            emit('on-click', announcement.id);
        }

        watch(() => props.announcements, announcementsChanged, {immediate: true, deep: true});

        return {
            announcementList,
            emptyState,
            formatDate,
            onRowClick,
        }
    }
});
